import HttpService from 'Support/services/HttpService';

class ReportsRequest {
  static baseUrl() {
    return 'v1/export/relatorio';
  }

  static list(params = {}) {
    return HttpService.get(
      `${this.baseUrl()}/todos`,
      {
        params,
      },
    );
  }

  static generate(id) {
    return HttpService.get(`${this.baseUrl()}/download/${id}`, {
      responseType: 'blob',
    });
  }
}

export default ReportsRequest;
